class Modal extends HTMLElement {
  constructor() {
    super();
    this.openBtn = this.querySelector('[data-modal-open]');
    this.closeBtn = this.querySelector('[data-modal-close]');
    this.content = this.querySelector('[data-modal-content]');
    this.innerContent = this.querySelector('[data-inner-content]');
    this.delay = this.dataset.delay ? parseInt(this.dataset.delay, 10) : 200;

    // Bind event handlers
    this.handleBodyClick = this.handleBodyClick.bind(this);
    this.handleEscapeKey = this.handleEscapeKey.bind(this);
  }

  connectedCallback() {
    // Open modal event
    this.openBtn.addEventListener('click', () => {
      this.open();
    });

    // Close modal event
    this.closeBtn.addEventListener('click', () => {
      this.close();
    });
  }

  open() {
    // Save the current scroll position
    this.scrollY = window.scrollY;

    // Display the modal
    this.content.classList.replace('hidden', 'flex');
    setTimeout(() => {
      this.content.classList.remove('opacity-0');
    }, 10);

    // Disable scrolling on the main page
    document.body.style.top = `-${this.scrollY}px`;
    document.body.classList.add('no-scroll');
    document.documentElement.classList.add('no-scroll'); // Apply to <html> as well

    // Add event listeners for closing the modal
    window.addEventListener('click', this.handleBodyClick);
    window.addEventListener('keydown', this.handleEscapeKey);
  }

  close() {
    // Hide the modal
    this.content.classList.add('opacity-0');
    setTimeout(() => {
      this.content.classList.replace('flex', 'hidden');
    }, this.delay);

    // Enable scrolling on the main page
    document.body.classList.remove('no-scroll');
    document.documentElement.classList.remove('no-scroll');
    document.body.style.top = '';

    // Restore the scroll position
    window.scrollTo(0, this.scrollY);

    // Remove event listeners for closing the modal
    window.removeEventListener('click', this.handleBodyClick);
    window.removeEventListener('keydown', this.handleEscapeKey);
  }

  handleBodyClick(e) {
    const { target } = e;
    if (
      target !== this.innerContent &&
      !target.closest('[data-inner-content]') &&
      !target.closest('[data-modal-open]') &&
      !target.closest('[data-tab-menu]')
    ) {
      this.close();
    }
  }

  handleEscapeKey(e) {
    if (e.key === 'Escape') {
      this.close();
    }
  }
}

customElements.define('custom-modal', Modal);
